// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Stq6","inner":"Footer_inner__sw6nr"};